import type { ICurrentAppService } from "@/data/services/CurrentAppService";

import { TastierClient } from "@/app/TastierClient";

export class AppCurrentAppService implements ICurrentAppService {
    public getNativeAppMode(): boolean {
        return TastierClient?.context?.getNativeAppMode() ?? false;
    }

    getIsWalleeSdkAvailable(): boolean | undefined {
        return TastierClient?.context?.getIsWalleeSdkAvailable();
    }
}
